import template   from './payment-worldpay.html'
import controller from './payment-worldpay.controller'
import './payment-worldpay.styl'

let component = {
  restrict: 'E',
  bindings: {
    productRef: '<',
    voucherInfos: '<',
    purchaseInfos: '<',
    validForm: '=',
    errorPurchase: '='
  },
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/my-purchase/buy-product/payment-worldpay/payment-worldpay.component.js